import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import HeaderLogo from "../../assets/HeaderLogo.svg";
import Filters from "../Filters";
import HeaderLoadingSkeleton from "../HeaderLoadingSkeleton";
import FiltersButtonsLoadingSkeleton from "../FilterButtonsLoadingSkeleton";
import TourSkipped from "../TourSkipped";
import BetShuffle from "../BetShuffle";
import styles from "./Header.module.scss";
import BetShuffleLoadingSkeleton from "../BetShuffleLoadingSkeleton";
import OnboardingInfoLoadingSkeleton from "../OnboardingInfoLoadingSkeleton";

const Header = ({ showOnboarding, closeOnboarding }) => {
  const { ppConfig } = useSelector((state) => state.filter);
  const isLoading = Object.keys(ppConfig).length === 0;

  const showPrompt = true;

  return (
    <>
      {isLoading ? (
        <div className={styles.loading}>
          <div className={styles.headerBannerLoadingSkeleton} />
          <FiltersButtonsLoadingSkeleton />
          <OnboardingInfoLoadingSkeleton />
          <BetShuffleLoadingSkeleton />
          <HeaderLoadingSkeleton />
        </div>
      ) : null}
      <div className={styles.header} role="banner">
        <picture>
          <img
            className={styles.headerImage}
            src={HeaderLogo}
            alt="Paddy Power Mix 'N Match Bet Builder Logo"
          />
        </picture>
        <Filters />
        {/* If the user has skipped the onboarding then we want to show the promp */}
        {showPrompt ? <TourSkipped showOnboarding={showOnboarding} /> : null}
        <BetShuffle closeOnboarding={closeOnboarding} />
      </div>
    </>
  );
};

Header.propTypes = {
  showOnboarding: PropTypes.func.isRequired,
  closeOnboarding: PropTypes.func.isRequired,
};

export default Header;
